import React, { Fragment, useEffect, useState } from "react"
import { Modal } from 'react-bootstrap'

import { formatDate } from 'helpers/helpers'
import { httpOk, GET } from 'helpers/api'

// Разбивка точек по версиям кассы под тот же фильтр, что и таблица:
// статусы, регион, партнёр, поиск и «без тестовых» уходят на сервер как есть.
function ModalPosVersions({ show, onHide, filterData }) {
	const [data, setData] = useState(null)
	const [opened, setOpened] = useState(null)

	async function getData() {
		const params = {}
		if (filterData?.search)
			params.search = filterData.search
		if (filterData?.region_id)
			params.region_id = filterData.region_id
		if (filterData?.partner_id)
			params.partner_id = filterData.partner_id
		if (filterData?.service_id)
			params.service_id = filterData.service_id
		if (filterData?.status_ids?.length)
			params.status_ids = filterData.status_ids.map(item => item.id).join(',')
		if (filterData?.tariff_not_zero)
			params.tariff_not_zero = 1
		if (filterData?.credit_only)
			params.credit_only = 1

		const response = await GET('/admin/pos/versions', params, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		if (show) {
			setOpened(null)
			getData()
		} else {
			setData(null)
		}
	}, [show]) // eslint-disable-line react-hooks/exhaustive-deps

	const total = data?.total ?? 0
	const groups = data?.data ?? []
	const statusNames = (filterData?.status_ids ?? []).map(item => item.name).join(', ')

	return (
		<Modal show={show} animation={false} centered size="lg"
			onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>Версии кассы</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex flex-wrap align-items-center gap-2 mb-2" style={{ fontSize: 13 }}>
					<span>Точек: <b>{total}</b></span>
					<span className="text-muted">· версий: <b>{groups.filter(item => item.version).length}</b></span>
					<span className="text-muted ms-auto">
						{statusNames ? `Статус: ${statusNames}` : 'Все статусы'}
						{filterData?.tariff_not_zero ? ' · без тестовых' : ''}
						{filterData?.credit_only ? ' · в кредите' : ''}
						{filterData?.search ? ` · поиск «${filterData.search}»` : ''}
					</span>
				</div>

				{/* высота фиксированная: раскрытая версия не должна двигать модалку */}
				<div className="table-responsive" style={{ height: 480, maxHeight: '60vh', overflowY: 'auto' }}>
					<table className="table table-bordered table-hover mb-0" style={{ fontSize: 13 }}>
						<thead style={{ position: 'sticky', top: 0, background: 'var(--dark-surface, #fff)', zIndex: 1 }}>
							<tr>
								<th style={{ width: 40 }} className="text-center">#</th>
								<th style={{ width: 140 }}>Версия</th>
								<th className="text-end" style={{ width: 80 }}>Точек</th>
								<th>Доля</th>
							</tr>
						</thead>
						<tbody>
							{groups.map((item, index) => {
								const key = item.version ?? ''
								const isOpened = opened === key
								const percent = total ? item.total * 100 / total : 0
								return (
									<Fragment key={key}>
										<tr style={{ cursor: 'pointer' }}
											onClick={() => setOpened(isOpened ? null : key)}>
											<td className="text-center">{index + 1}</td>
											<td className="text-nowrap fw-semibold">
												<i className={`uil ${isOpened ? 'uil-angle-down' : 'uil-angle-right'} me-1`}></i>
												{item.version || <span className="text-muted fw-normal">Нет версии</span>}
											</td>
											<td className="text-end fw-semibold">{item.total}</td>
											<td>
												<div className="d-flex align-items-center gap-2">
													<div className="progress flex-grow-1" style={{ height: 8 }}>
														<div className={`progress-bar ${index === 0 && item.version ? 'bg-success' : ''}`}
															style={{ width: `${percent}%` }}></div>
													</div>
													<span className="text-muted text-end" style={{ width: 48 }}>
														{percent.toFixed(1)}%
													</span>
												</div>
											</td>
										</tr>
										{isOpened && item.poses.map(pos => (
											<tr key={`${key}-${pos.id}`} style={{ background: 'var(--dark-surface-2, #f8f9fa)' }}>
												<td></td>
												<td className="text-muted">#{pos.id}</td>
												<td colSpan={2}>
													<div className="d-flex gap-2">
														<span className="text-nowrap">{pos.login}</span>
														<span>{pos.name}</span>
														<span className="text-muted text-nowrap ms-auto">
															{pos.last_cheque_date ? `чек ${formatDate(pos.last_cheque_date)}` : 'чеков нет'}
														</span>
													</div>
												</td>
											</tr>
										))}
									</Fragment>
								)
							})}
							{data && groups.length === 0 &&
								<tr>
									<td colSpan={4} className="text-center text-muted">Точек нет</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default ModalPosVersions
